<template>
  <Sheet
    :visible="visible"
    :title="$t('Account Notes')"
    :width="700"
    @close="visible = false"
    padded
  >
    <div id="AccountNotesModal">
      <!-- <Card>
        <CardSection>
          <template>
            <TextField v-model="newNote" :disabled="saving" multiline>
              <template #right>
                <Button type="primary" @click="saveNewNote" :disabled="saving">{{$t('Add Note')}}</Button>
              </template>
            </TextField>
          </template>
        </CardSection>
      </Card> -->
      <Card>
        <Filters :query.sync="filter"/>
        <Tabs
          :tabs="tabs"
          v-model="selected"
        />
        <div class="Modal-notes">
          <div v-if="loading" class="Modal-notes-none">{{$t('Loading')}} ...</div>
          <div v-if="!loading && filteredNotes.length === 0" class="Modal-notes-none">{{$t('Nothing to see here')}} ...</div>
          <template v-if="filteredNotes.length">
            <div
              v-for="note in filteredNotes"
              :key="note.id"
              class="note"
            >
              <div class="head">
                <span class="type">
                  <!-- <Icon :icon="getNoteTypeIcon(note)"/> -->
                  <router-link v-if="getObjectLink(note)" :to="getObjectLink(note)" tag="a" target="_blank">{{ getNoteTypeName(note) }}</router-link>
                  <span v-else>{{ getNoteTypeName(note) }}</span>
                  <div><Caption>{{ getNoteType(note) }}</Caption></div>
                </span>
                <div class="note-info">
                  <Formatter class="note-date" type="dateTimeShort" :value="note.createdOn" />
                  <div class="note-author">{{ note.createdByName }}</div>
                </div>
                <!-- <span v-if="shouldShowDelete(note)" class="delete">
                  <Icon @click="deleteNote(note)" icon="fas fa-times"/>
                </span> -->
              </div>
              <!-- <pre style="white-space: pre-wrap; word-wrap: break-word; padding-right: 100px;">{{JSON.stringify(note, null, 2)}}</pre> -->
              <!-- <pre style="white-space: pre-wrap;">{{note.notes}}</pre> -->
              <!-- <div v-if="note.objectType === 'ABTESTING'" class="details"></div> -->
              <div v-if="note.objectAction === 'CREATE'" class="details">
                {{$t('AccountNotes.addedConversionDefinition')}}
                <!-- <pre>{{getNotesObject(note)}}</pre> -->
                <div class="inner-stats">
                  <Stats class="inner-stats">
                    <Stat :label="$t('ID')" :value="getNotesObject(note).id"/>
                    <Stat :label="$t('Name')" :value="getNotesObject(note).name"/>
                    <Stat :label="$t('ConversionDefinitions.ruleX', { value: 1 })" :value="getConversionRuleLabel(getNotesObject(note).action1Type)"/>
                    <Stat :label="$t('ConversionDefinitions.ruleXReference', { value: 1 })" :value="getNotesObject(note).action1Reference"/>
                    <Stat v-if="getNotesObject(note).action2Type" :label="$t('ConversionDefinitions.ruleX', { value: 2 })" :value="getConversionRuleLabel(getNotesObject(note).action2Type)"/>
                    <Stat v-if="getNotesObject(note).action2Type" :label="$t('ConversionDefinitions.ruleXReference', { value: 2 })" :value="getNotesObject(note).action2Reference"/>
                    <Stat v-if="getNotesObject(note).action3Type" :label="$t('ConversionDefinitions.ruleX', { value: 3 })" :value="getConversionRuleLabel(getNotesObject(note).action3Type)"/>
                    <Stat v-if="getNotesObject(note).action3Type" :label="$t('ConversionDefinitions.ruleXReference', { value: 3 })" :value="getNotesObject(note).action3Reference"/>
                    <Stat :label="$t('ConversionDefinitions.chargeType')" :value="getNotesObject(note).chargeType === 'P' ? $t('ConversionDefinitions.Percent') : $t('ConversionDefinitions.Fixed')"/>
                    <Stat v-if="getNotesObject(note).chargeType === 'P'" type="percent" :label="$t('ConversionDefinitions.chargeRate')" :value="getNotesObject(note).chargeRate / 100"/>
                    <Stat v-else type="currency" :currency="theUser ? theUser.accountCurrency: 'USD'" :label="$t('ConversionDefinitions.chargeRate')" :value="getNotesObject(note).chargeRate"/>
                  </Stats>
                </div>
              </div>
              <div v-else class="details" v-html="getFormattedNotes(note)"></div>
              <!-- <pre>{{note}}</pre> -->
            </div>
          </template>
        </div>
        <div v-if="!loading && notes.length && notes.length === ELEMENTS_SHOWN" class="footer">
          <Button v-if="!loadingMore" :fullWidth="true" @click="loadMoreNotes">{{$t('CampaignNotes.Load More')}}</Button>
          <SkeletonBodyText v-else/>
        </div>
      </Card>
    </div>

  </Sheet>
</template>

<script>
const ELEMENTS_SHOWN = 100
export default {
  name: 'AccountNotesSheet',
  data() {
    return {
      visible: false,
      notes: [],
      loading: true,
      loadingMore: false,
      selected: 'ALL',
      filter: '',
      newNote: '',
      conversionRules: null,
      // options: {},
      saving: false,
      // initialsColor: {},
      offset: 0,
      limit: ELEMENTS_SHOWN
    }
  },
  created() {
    this.eventHub.$on('showAccountNotes', (type = 'ALL') => {
      this.visible = true
      this.offset = 0
      this.limit = ELEMENTS_SHOWN
      this.filter = ''
      this.selected = type
      this.$watch('selected', this.reloadNotes)
      NProgress.start()
      Promise.all([
        this.api.getAccountNotes(this.offset, this.limit, this.selected),
        this.api.getConversionDefinitionRules()
      ])
        .then((response) => { 
          const [notes, rules] = response
          this.notes = notes.data || notes
          this.conversionRules = (rules.data || rules).map(dr => {
            return {
              ...dr,
              label: this.$t(dr.label),
              help: this.$t(dr.help)
            }
          })
          this.loading = false
        })
        .catch(this.apiCatch)
        .finally(() => {
          NProgress.done()
        })
    })
  },
  beforeDestroy() {
    this.eventHub.$off('showAccountNotes')
  },
  computed: {
    tabs() {
      return [
        { id: 'ALL', label: this.$t('All') },
        { id: 'CONVERSIONDEFINITION', label: this.$t('Conversion Definition') },
        { id: 'WIDGETREVISION', label: this.$t('Widget Revision')}
      ]
    },
    filteredNotes() {
      let notes = this.notes
      if (this.selected) {
        if (this.selected !== 'ALL') {
          notes = this.notes.filter(note => note.objectType === this.selected)
        }
      }
      if (this.filter) {
        const filter = this.filter.toLowerCase()
        notes = this.notes.filter((note) => {
          if (note.createdByName.toLowerCase().indexOf(filter) > -1) {
            return true
          }
          if (note.notes.toLowerCase().indexOf(filter) > -1) {
            return true
          }
          if (note.objectName.toLowerCase().indexOf(filter) > -1) {
            return true
          }
          return false
        })
      }
      return notes
    }
  },
  methods: {
    reloadNotes() {
      this.loading = true
      this.notes = []
      this.api.getAccountNotes(this.offset, this.limit, this.selected)
        .then((response) => {
          this.notes = response.data || response
          this.loading = false
        })
        .catch(this.apiCatch)
    },
    loadMoreNotes() {
      this.offset += ELEMENTS_SHOWN
      this.loadingMore = true
      this.api.getAccountNotes(this.offset, this.limit, this.selected)
        .then((response) => { 
          this.notes.push(...(response.data || response))
          this.loadingMore = false
        })
        .catch(this.apiCatch)
    },
    getObjectLink(note) {
      if (note.objectType === 'CONVERSIONDEFINITION') {
        return `/account/conversion-definitions`
      }
      if (note.objectType === 'WIDGETREVISION') {
        return ``
      }
      return ''
    },
    getNoteTypeName(note) {
      if (note.objectType === 'CONVERSIONDEFINITION') {
        return note.objectName || this.$t('Conversion Definition')
      }
      if (note.objectType === 'WIDGETREVISION') {
        return note.objectName || `#${note.objectId} — ${this.$t('Widget Revision')}`
      }
      return this.$t('Unknown')
    },
    getNoteType(note) {
      const t = this.tabs.find(t => t.id === note.objectType)
      return t ? t.label : '?'
    },
    getConversionRuleLabel(rule) {
      const foundRule = this.conversionRules && this.conversionRules.find(r => r.value === rule)
      return foundRule && foundRule.label || ''
    },
    shouldShowDelete(note) {
      if (this.theUser && note.objectType === 'NOTES' && window.moment.tz(window.moment(), this.theUser.accountTimezone).diff(window.moment.tz(note.createdOn, this.theUser.accountTimezone)) / 1000 / 60 < 10) {
        return true
      }
      return false
    },
    // saveNewNote() {
    //   if (this.newNote.trim().length === 0) {
    //     return
    //   }
    //   NProgress.start()
    //   this.saving = true
    //   this.api.addCampaignNote(this.campaignId, this.newNote)
    //     .then((newNoteId) => {
    //       // add to list
    //       this.notes.unshift({
    //         id: newNoteId,
    //         campaignId: this.campaignId,
    //         notes: this.newNote,
    //         objectType: 'NOTES',
    //         objectId: this.campaignId,
    //         userId: -1,
    //         accountId: -1,
    //         onBehalfOfAccountId: null,
    //         createdBy: -1,
    //         createdOn: window.moment.utc().format('YYYY-MM-DD HH:mm:ss'),
    //         createdByName: this.$t('Me')
    //       })

    //       this.newNote = ''
    //     })
    //     .catch(this.apiCatch)
    //     .finally(() => {
    //       NProgress.done()
    //       this.saving = false
    //     })
    // },
    // deleteNote(note) {
    //   NProgress.start()
    //   this.api.removeCampaignNote(this.campaignId, note)
    //     .then(() => {
    //       let noteIndex = -1
    //       this.notes.forEach((n, index) => {
    //         if (n.id === note.id) {
    //           noteIndex = index
    //         }
    //       })
    //       if (noteIndex > -1) {
    //         this.notes.splice(noteIndex, 1)
    //       } else {
    //         this.$ui.alert(this.$t('CampaignNotes.Could not find note to remove'))
    //       }
    //     })
    //     .catch(this.apiCatch)
    //     .finally(() => {
    //       NProgress.done()
    //     })
    // },
    getFormattedNotes(note) {
      if (note.notes.charAt(0) !== '[') {
        return note.notes
      }
      let notesObj
      try {
        notesObj = JSON.parse(note.notes)
      } catch (e) {
        return 'ERROR'
      }
      let str = '<ul>'
      notesObj.forEach((noteInner) => {
        noteInner.attribute = this.parseAttributeForTrans(noteInner.attribute)
        let isBothJson = true
        let oldValueJson
        let newValueJson
        try {
          oldValueJson = JSON.parse(noteInner.oldValue)
        } catch(e) {
          isBothJson = false
        }
        try {
          newValueJson = JSON.parse(noteInner.newValue)
        } catch(e) {
          isBothJson = false
        }
        let doAsJson = false
        if (oldValueJson && newValueJson && (typeof oldValueJson === 'object' || (typeof oldValueJson === 'object' && typeof newValueJson === 'object'))) {
          doAsJson = true
        }
        if (doAsJson && isBothJson && oldValueJson && newValueJson && typeof oldValueJson === 'object' && typeof newValueJson === 'object') {
          str += `<li><strong>${noteInner.attribute}</strong><table style="margin-top: 2px;" class="table table-bordered change-table">`
          Object.keys(oldValueJson).forEach((key) => {
            if (oldValueJson[key] === null) oldValueJson[key] = ''
            if (newValueJson[key] === null) newValueJson[key] = ''
            if (JSON.stringify(oldValueJson[key]) !== JSON.stringify(newValueJson[key])) {
              str += `<tr><td>${this.niceKey(key)}</td><td>${oldValueJson[key]}</td><td>${newValueJson[key]}</td></tr>`
            }
          })
          str += '</table></li>'
        } else if (doAsJson && newValueJson) {
          str += `<li><strong>${noteInner.attribute}</strong><table style="margin-top: 2px;" class="table table-bordered change-table">`
          Object.keys(newValueJson).forEach((key) => {
            if (newValueJson[key] === null) return
            str += `<tr><td>${this.niceKey(key)}</td><td>${newValueJson[key]}</td></tr>`
          })
          str += '</table></li>'
        } else if ((noteInner.newValue !== undefined)) {
          str += `<li>${this.$t('CampaignNotes.fromTo', {
            attr: noteInner.attribute,
            old: this.fixValue(noteInner.oldValue),
            new: this.fixValue(noteInner.newValue),
          })}</li>`
        } else if ((noteInner.newValue === undefined && noteInner.oldValue === undefined)) {
          str += `<li>${noteInner.attribute}</li>`
        }
      })
      str += '</ul>'
      return str
    },
    niceKey(val) {
      return val.charAt(0).toUpperCase() + val.substr(1).replace(/([A-Z])/g, ' $1')
    },
    getNotesObject(note) {
      return JSON.parse(note.notes) || {}
    },
    parseAttributeForTrans(attribute) {
      return this.$t(`${attribute}`)
    },
    niceRuleValue(val) {
      if (val === true) {
        return this.$t('TRUE')
      }
      if (val === false) {
        return this.$t('FALSE')
      }
      if (val === 0) {
        return '0'
      }
      if (!val) {
        return ''
      }
      return val
    },
    fixValue(value) {
      if (value === null || value === undefined || value === '') {
        return '""'
      }
      if (typeof(value) === 'object') {
        return JSON.stringify(value)
      }
      return value
    }
  }
}
</script>

<style lang="scss">
#AccountNotesModal {
  font-size: 14px;
  .Modal-notes {
    // height: 50vh;
    overflow: hidden;
    // border: 1px solid #ccc;
    // overflow-y: scroll;
    .delete {
      margin-left: 15px;
      margin-top: -2px;
      cursor: pointer;
    }
    .note {
      hr {
        width: 80%;
        margin-top: 10px;
        margin-bottom: 10px;
      }
      .head {
        display: flex;
        align-items: center;
        background: #f5f5f5;
        padding: 10px;
        border-top: 1px solid #ddd;
        .type {
          flex: 1;
          i {
            color: #fff;
            background: #9999;
            font-size: 15px;
            width: 25px;
            height: 25px;
            border-radius: 50%;
            display: inline-block;
            padding: 5px;
            padding-left: 4px;
            margin-right: 5px;
          }
        }
        .note-info {
          color: #666;
          font-size: 80%;
          text-align: right;
        }
      }
      .details {
        margin: 15px;
        font-size: 110%;
        .inner-stats {
          margin: 10px;
        }
      }
    }
  }

  .footer {
    padding: 10px 15px;
    border-top: 1px solid #ccc;
  }
  .red {
    color: red;
  }

  ul > li {
    margin-top: 8px;
  }
  ul > li:first-of-type {
    margin-top: 0px;
  }

  .Modal-notes-none {
    text-align: center;
    margin-top: 30px;
    margin-bottom: 30px;
    font-size: 120%;
    color: #666;
  }
  table.change-table {
    margin-top: 5px;
    // margin-left: -9px;
    font-size: 90%;
    border-radius: 0px;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
    td {
      padding: 3px;
      vertical-align: top;
      line-height: 22px;
      text-align: left;
    }
  }
}
</style>
